export const V6_EDUCATION_LEVELS_COMP_SURVEY = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true
  },
  {
    value: 'SOME_HIGH_SCHOOL_OR_LESS',
    label: /* TRANSLATORS: education level */ getText(
      'Some High School or Less'
    )
  },
  {
    value: 'HIGH_SCHOOL_DIPLOMA_GED',
    label: /* TRANSLATORS: education level */ getText(
      'High School Diploma / G.E.D.'
    )
  },
  {
    value: '2_YEAR_DEGREE',
    label: /* TRANSLATORS: education level */ getText('2-Year Degree')
  },
  {
    value: '4_YEAR_DEGREE',
    label: /* TRANSLATORS: education level */ getText('4-Year Degree')
  },
  {
    value: 'MASTERS_DEGREE',
    label: /* TRANSLATORS: education level */ getText(
      "Master's Degree (M.A., M.B.A., etc.)"
    )
  },
  {
    value: 'JURIS_DOCTOR',
    label: /* TRANSLATORS: education level */ getText('Juris Doctor (J.D.)')
  },
  {
    value: 'DOCTORATE',
    label: /* TRANSLATORS: education level */ getText('Doctorate (Ph.D.)')
  },
  {
    value: 'MEDICAL_DOCTOR',
    label: /* TRANSLATORS: education level */ getText('Medical Doctor (M.D.)')
  }
];

export const V4_EMPLOYER_BUDGET_BUCKETS = [
  {
    value: '',
    label: getText('Select One'),
    hidden: true,

    disabled: true
  },
  {
    value: 'LT_500K',
    label: /* TRANSLATORS: employer budget buckets */ getText('<$501k')
  },
  {
    value: '500K_TO_1M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$500k - Up to $1 million'
    )
  },
  {
    value: '1M_TO_5M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$1 million - Up to $5 million'
    )
  },
  {
    value: '5M_TO_10M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$5 million - Up to $10 million'
    )
  },
  {
    value: '10M_TO_25M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$5 million - Up to $10 million'
    )
  },
  {
    value: '25M_TO_50M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$25 million - Up to $50 million'
    )
  },
  {
    value: '50M_TO_100M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      '$50 million - Up to $100 million'
    )
  },
  {
    value: 'GT_100M',
    label: /* TRANSLATORS: employer budget buckets */ getText(
      'More than $100 million'
    )
  },
  {
    value: 'OTHER',
    label: /* TRANSLATORS: employer budget buckets */ getText('Other')
  }
];

export const V4_NUMBER_OF_FT_EMPLOYEES_BUCKETS = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true
  },
  {
    value: '1_TO_10',
    label: /* TRANSLATORS: employer budget buckets */ getText('1-10')
  },
  {
    value: '11_TO_25',
    label: /* TRANSLATORS: employer budget buckets */ getText('11-25')
  },
  {
    value: '26_TO_50',
    label: /* TRANSLATORS: employer budget buckets */ getText('26-50')
  },
  {
    value: '51_TO_100',
    label: /* TRANSLATORS: employer budget buckets */ getText('51-100')
  },
  {
    value: '101_TO_250',
    label: /* TRANSLATORS: employer budget buckets */ getText('101-250')
  },
  {
    value: '251_TO_500',
    label: /* TRANSLATORS: employer budget buckets */ getText('251-500')
  },
  {
    value: '501_TO_1000',
    label: /* TRANSLATORS: employer budget buckets */ getText('501-1000')
  },
  {
    value: 'GT_1000',
    label: /* TRANSLATORS: employer budget buckets */ getText('>1000')
  }
];

export const ISSUE_BASED_ORGANIZATION_SUB_TYPES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true
  },
  {
    value: 'AGRICULTURE',
    label: getText('Agriculture')
  },
  {
    value: 'ANIMALS',
    label: getText('Animals')
  },
  {
    value: 'CIVIC_ENGAGEMENT',
    label: getText('Civic Engagement')
  },
  {
    value: 'CLIMATE_CHANGE',
    label: getText('Climate Change')
  },
  {
    value: 'COMMUNICATIONS_ACCESS',
    label: getText('Communications Access')
  },
  {
    value: 'COMMUNITY_DEVELOPMENT',
    label: getText('Community Development')
  },
  {
    value: 'CONFLICT_RESOLUTION',
    label: getText('Conflict Resolution')
  },
  {
    value: 'CONSUMER_PROTECTION',
    label: getText('Consumer Protection')
  },
  {
    value: 'CRIME_SAFETY',
    label: getText('Crime & Safety')
  },
  {
    value: 'DISABILITY',
    label: getText('Disability')
  },
  {
    value: 'DISASTER_RELIEF',
    label: getText('Disaster Relief')
  },
  {
    value: 'ECONOMIC_DEVELOPMENT',
    label: getText('Economic Development')
  },
  {
    value: 'EDUCATION',
    label: getText('Education'),
    description: `Nonprofits in this space may offer afterschool programs, citizenship classes, training opportunities, or tutoring.`
  },
  {
    value: 'ENERGY',
    label: getText('Energy')
  },
  {
    value: 'ENTREPRENEURSHIP',
    label: getText('Entrepreneurship')
  },
  {
    value: 'ENVIRONMENT',
    label: getText('Environment')
  },
  {
    value: 'FAMILY',
    label: getText('Family')
  },
  {
    value: 'FINANCIAL_LITERACY_PERSONAL_FINANCE',
    label: getText('Financial Literacy & Personal Finance')
  },
  {
    value: 'HEALTH_MEDICINE',
    label: getText('Health & Medicine'),
    description: `Focuses on community-based healthcare, global health, specific conditions or diseases, and much more.`
  },
  {
    value: 'HOUSING_HOMELESSNESS',
    label: getText('Housing & Homelessness')
  },
  {
    value: 'HUMAN_RIGHTS_CIVIL_LIBERTIES',
    label: getText('Human Rights & Civil Liberties')
  },
  {
    value: 'HUNGER_FOOD_SECURITY',
    label: getText('Hunger, Food Security')
  },
  {
    value: 'IMMIGRANTS_OR_REFUGEES',
    label: getText('Immigrants or Refugees')
  },
  {
    value: 'INTERNATIONAL_RELATIONS',
    label: getText('International Relations')
  },
  {
    value: 'JOB_WORKPLACE',
    label: getText('Job & Workplace')
  },
  {
    value: 'LGBTQ',
    label: getText('LGBTQ')
  },
  {
    value: 'LEGAL_ASSISTANCE',
    label: getText('Legal Assistance')
  },
  {
    value: 'MEDIA',
    label: getText('Media')
  },
  {
    value: 'MEN',
    label: getText('Men')
  },
  {
    value: 'MENTAL_HEALTH',
    label: getText('Mental Health')
  },
  {
    value: 'MICROFINANCE',
    label: getText('Microfinance')
  },
  {
    value: 'POVERTY',
    label: getText('Poverty')
  },
  {
    value: 'PRISON_REFORM',
    label: getText('Prison Reform')
  },
  {
    value: 'RACE_ETHNICITY',
    label: getText('Race & Ethnicity')
  },
  {
    value: 'RELIGION_SPIRITUALITY',
    label: getText('Religion & Spirituality'),
    description: `May work on ethical issues, interfaith coalitions, or the intersection of culture and religion`
  },
  {
    value: 'REPRODUCTIVE_HEALTH_RIGHTS',
    label: getText('Reproductive Health/Rights')
  },
  {
    value: 'RESEARCH_SOCIAL_SCIENCE',
    label: getText('Research & Social Science')
  },
  {
    value: 'RURAL_AREAS',
    label: getText('Rural Areas')
  },
  {
    value: 'SCIENCE_TECHNOLOGY',
    label: getText('Science & Technology')
  },
  {
    value: 'SENIORS_RETIREMENT',
    label: getText('Seniors & Retirement')
  },
  {
    value: 'SEXUAL_ABUSE_HUMAN_TRAFFICKING',
    label: getText('Sexual Abuse & Human Trafficking')
  },
  {
    value: 'SPORTS_RECREATION',
    label: getText('Sports & Recreation')
  },
  {
    value: 'SUBSTANCE_ABUSE_ADDICTION',
    label: getText('Substance Abuse & Addiction')
  },
  {
    value: 'TRANSPARENCY_OVERSIGHT',
    label: getText('Transparency & Oversight')
  },
  {
    value: 'TRANSPORTATION',
    label: getText('Transportation')
  },
  {
    value: 'TRAVEL_HOSPITALITY',
    label: getText('Travel & Hospitality')
  },
  {
    value: 'URBAN_AREAS',
    label: getText('Urban Areas')
  },
  {
    value: 'VETERANS',
    label: getText('Veterans')
  },
  {
    value: 'VICTIM_SUPPORT',
    label: getText('Victim Support')
  },
  {
    value: 'VOLUNTEERING',
    label: getText('Volunteering')
  },
  {
    value: 'WATER_SANITATION',
    label: getText('Water & Sanitation')
  },
  {
    value: 'WOMEN',
    label: getText('Women')
  }
];

export const V5_EMPLOYER_ORG_TYPES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true
  },
  {
    value: 'ARTS_CULTURE_AND_HUMANITIES',
    label: getText('Arts, Culture, and Humanities'),
    description: `Organizations include historical societies, landmark preservation, libraries, museums, and performing arts organizations.`
  },
  {
    value: 'FOUNDATION_OR_GRANTMAKING_INSTITUTION',
    label: getText('Foundation or Grantmaking Institution'),
    description: `A nonprofit or charitable trust that makes grants to organizations, institutions, or individuals for charitable purposes. Organizations include community foundations, private foundations, and grantmaking public charities.`
  },
  {
    value: 'HIGHER_EDUCATION',
    label: getText('Higher Education'),
    description: `Organizations include academies, colleges, conservatories, institutes of technology, seminaries, and universities.`
  },
  {
    value: 'HOSPITAL_CLINIC_OR_MEDICAL_RESEARCH_FACILITY',
    label: getText('Hospital, Clinic, or Medical Research Facility'),
    description: `Health care institutions that provide medical treatment. Organizations include general hospitals, teaching hospitals, specialized hospitals, medical centers, and medical research institutes.`
  },
  {
    value: 'ISSUE_BASED_ORGANIZATION',
    label: getText('Issue-Based Organization (select to see more)'),
    subTypes: ISSUE_BASED_ORGANIZATION_SUB_TYPES,
    subTypeLabel: getText('Issue-Based Organization')
  },
  {
    value: 'MEMBERSHIP_ORGANIZATION',
    label: getText('Membership Organization'),
    description: `Connects people or institutions around an interest, geographical location, or profession, often for a fee or dues. Organizations include professional and trade associations, political parties, and voluntary associations.`
  },
  {
    value: 'PUBLIC_OR_PRIVATE_SCHOOL_K12',
    label: getText('Public or Private School, K-12 (select to see more)'),
    subTypes: [
      {
        value: '',
        label: getText('My school is a...'),
        disabled: true,
        hidden: true
      },
      {
        value: 'PUBLIC_NONPROFIT_CHARTER_SCHOOL',
        label: getText('Public Nonprofit Charter School')
      },
      {
        value: 'PRIVATE_NONPROFIT_SCHOOL',
        label: getText('Private Nonprofit School')
      },
      {
        value: 'PUBLIC_INSTITUTION_LOCAL_GOV',
        label: getText(
          'Public Institution Funded and Operated by Local Government'
        )
      }
    ],
    subTypeLabel: getText('School')
  },
  {
    value: 'RELIGIOUS_OR_FAITH_BASED_INSTITUTION',
    label: getText('Religious or Faith-Based Institution'),
    description: `Exists to support and manage the practice of a specific set of religious beliefs. Organizations include churches, mosques, synagogues, and temples.`
  },
  {
    value: 'THINK_TANK_OR_POLICY_INSTITUTE',
    label: getText('Think Tank or Policy Institute'),
    description: `Performs research and advocacy concerning issue-oriented topics such as social policy, political strategy, economics, military, technology, and culture.`
  }
];

export const V4_GENDERS = [
  { name: 'FEMALE', label: 'Female' },
  {
    name: 'NON_BINARY',
    label: 'Gender Non-Binary, Gender Non-Conforming, or Genderqueer'
  },
  { name: 'MALE', label: 'Male' },
  { name: 'TRANSGENDER', label: 'Transgender' },
  { name: 'OTHER', label: 'Prefer to self-describe' }
];

export const V4_RACES_AND_ETHNICITIES = [
  {
    name: 'NATIVE',
    label: 'American Indian, Native American, or Alaska Native'
  },
  { name: 'ARABIC', label: 'Arab American, Middle Eastern, or North African' },
  {
    name: 'ASIAN',
    label: 'Asian American, East Asian, South Asian, or South East Asian'
  },
  {
    name: 'BLACK',
    label: 'Black, African American, African, or African Descent'
  },
  { name: 'LATIN', label: 'Latina/o/x, Chicana/o/x, or Hispanic American' },
  {
    name: 'PACIFIC_ISLAND',
    label: 'Native Hawaiian or Other Pacific Islander'
  },
  { name: 'WHITE', label: 'White or European Descent' },
  { name: 'OTHER', label: 'Other race, ethnicity, or origin' }
];

export const V4_AGES = [
  {
    value: '',
    label: getText('Select One'),
    disabled: true
  },
  { value: 'LT_21', label: 'Under 21' },
  { value: '21_TO_29', label: '21-29' },
  { value: '30_TO_39', label: '30-39' },
  { value: '40_TO_49', label: '40-49' },
  { value: '50_TO_59', label: '50-59' },
  { value: 'GTE_60', label: '60 or older' }
];
